'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TypingMessageMetadata = (0, _immutable.Record)(_defineProperty({}, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.TYPING), 'TypingMessageMetadata');

exports.default = TypingMessageMetadata;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/PubNubMessageMetadata/TypingMessageMetadata.js
// module id = 317
// module chunks = 2 3